"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const MarketplaceSpotlightIcon = createSVGIcon(
  <>
    <path
      d="M5.267 20.2h6.4M11.667 20.202V9.535M16.025 14.56V7.246M7.4 20.2v-6.4M12.733 28.733h-9.6A2.133 2.133 0 0 1 1 26.6V3.133A2.133 2.133 0 0 1 3.133 1H18.25c.566 0 1.108.225 1.508.624l4.084 4.085c.4.4.625.942.625 1.508V10.6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.867 22.333a7.467 7.467 0 1 0 14.933 0 7.467 7.467 0 0 0-14.933 0ZM33 33.001l-5.41-5.364"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "MarketplaceSpotlightIcon",
  {
    viewBox: "0 0 34 34",
    titleAccess: "MarketplaceSpotlightIcon",
    fill: "none",
    color: "#888888",
  }
);
